import styled from 'styled-components';

import { RadioCard } from '@hero/components/atoms';

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  gap: 40px;
  width: 100%;
`;

const LeftContent = styled.div`
  display: flex;
  flex: 2;
  flex-direction: column;
  gap: 24px;
`;

const PaymentMethodArea = styled.div`
  display: grid !important;
  gap: 16px;
  grid-template-columns: repeat(3, 1fr);
  margin-bottom: 16px;
`;

const PaymentMethodItem = styled(RadioCard)`
  min-width: 100%;
  padding-left: 40px;
`;

const GiftSettingArea = styled.div`
  margin-top: 80px;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

const RightContent = styled.div`
  background: var(--color-bg-weaker);
  border-radius: var(--size-border-radius-md);
  flex: 1;
  padding: 40px;
`;

const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const Value = styled.div`
  color: var(--color-fg-default);
  font-weight: 700;
  min-width: fit-content;
`;

const TotalRow = styled.div`
  align-items: center;
  display: flex;
  font-size: 20px;
  font-weight: 700;
  justify-content: space-between;
  margin-bottom: 0;
`;

const CustomApprovalNotificationContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
`;

export {
  CardContainer,
  CustomApprovalNotificationContent,
  GiftSettingArea,
  LeftContent,
  PaymentMethodArea,
  PaymentMethodItem,
  RightContent,
  Row,
  TitleWrapper,
  TotalRow,
  Value,
  Wrapper
};
